import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = {
  key: 1,
  class: "link-text"
}
const _hoisted_4 = ["innerHTML"]

import { Configuration } from "@/guiide/ts/configuration/configuration";
import { ref, computed } from "vue";
import { useStore } from "vuex";
import Modal from "./Modal.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'Help',
  props: {
  title: { type: String, required: false, default: "" },
  text: { type: Object as () => Array<string>, required: false },
  isWide: { type: Boolean, required: false, default: false },
  color: { type: String, default: "" },
  enabled: { type: Boolean, default: true },
  display: { type: Boolean, default: true },
  icon: { type: String, default: "bi-question-circle-fill", required: false },
  fontSize: { type: String, default: "", required: false },
  linkText: { type: String, default: "", required: false }
},
  setup(__props, { expose: __expose }) {

const props = __props;

__expose({ takeFocus });

const store = useStore();
const showHelpAnchor = ref<HTMLElement>(null);
const helpModal = ref(null);

const customIcon = computed<string>(() => {
  return store.state.configuration?.customHelpIcon ?? "";
});

const hasCustomIcon = computed<boolean>(() => {
  return customIcon.value.length > 0;
});

const customStyle = computed<string>(() => {
  const selectedColor = props.color != null && props.color != ""
          ? props.color
          : Configuration.getCssVariableValue("--quaternary-color");

  let size = "";
  if (props.fontSize.length) {
    size = `font-size: ${props.fontSize};`
  }

  return `color: ${selectedColor};${size}`;
});

function getTitleWithoutSpaces() {
  return props.title.replace(/[^a-zA-Z0-9]+/g, "");
}

function getCloseButtonAriaLabel(): string {
  let helpText = "";

  for (const para of props.text) {
    const cleanedForAriaLabel = cleanHelpParaForAriaLabel(para);
    helpText += cleanedForAriaLabel + "\n";
  }

  return `Close button on "${props.title}" help popup, the help is: ${helpText}Press enter or space to close this help window.`;
}

function cleanHelpParaForAriaLabel(para: string): string {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = para;

  tempDiv.querySelectorAll("a").forEach((a) => {
    const href = a.getAttribute("href") || "";
    const linkText = href.trim();
    a.replaceWith(document.createTextNode(linkText));
  });

  tempDiv.querySelectorAll("strong").forEach((s) => {
    const capitalised = s.innerText?.toUpperCase() + ".\n";
    s.replaceWith(document.createTextNode(capitalised));
  });

  return tempDiv.textContent?.trim() ?? "";
}

function onHelpClick() {  
  if (props.enabled) {
    helpModal.value.showModal();
  }
}

function takeFocus(): boolean {
  if (!props.display) {
    return false;
  }
  showHelpAnchor.value.focus();
  return true;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.display)
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          ref_key: "showHelpAnchor",
          ref: showHelpAnchor,
          onClick: _withModifiers(onHelpClick, ["prevent"]),
          onKeydown: _withKeys(onHelpClick, ["enter"]),
          tabindex: "0",
          role: "button",
          "aria-label": `Open help on '${__props.title}'`,
          class: "help-link"
        }, [
          _cache[0] || (_cache[0] = _createElementVNode("span", { class: "visually-hidden-focusable" }, "Click this link to open the help content", -1)),
          (hasCustomIcon.value)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: customIcon.value,
                style: {"width":"1.2rem"},
                alt: `Learn more about ${__props.title}`
              }, null, 8, _hoisted_2))
            : (props.linkText.length > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(__props.linkText), 1))
              : (_openBlock(), _createElementBlock("i", {
                  key: 2,
                  class: _normalizeClass(["bi", __props.icon]),
                  style: _normalizeStyle(customStyle.value)
                }, null, 6))
        ], 40, _hoisted_1))
      : _createCommentVNode("", true),
    _createVNode(Modal, {
      ref_key: "helpModal",
      ref: helpModal,
      title: __props.title,
      "close-button-aria-label": getCloseButtonAriaLabel(),
      idKey: getTitleWithoutSpaces(),
      icon: "bi-question-circle-fill",
      isWide: __props.isWide,
      returnFocusTo: showHelpAnchor.value,
      customIconOverride: customIcon.value
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.text, (para, i) => {
          return (_openBlock(), _createElementBlock("p", {
            key: i,
            innerHTML: para
          }, null, 8, _hoisted_4))
        }), 128))
      ]),
      _: 1
    }, 8, ["title", "close-button-aria-label", "idKey", "isWide", "returnFocusTo", "customIconOverride"])
  ], 64))
}
}

})